import { combineReducers } from 'redux';
import types from './types';

const theme = (state = 'default', action) => {
  switch (action.type) {
    case types.SELECT_THEME:
      return action.theme || state;
    default:
      return state;
  }
};

const locale = (state = 'ja', action) => {
  switch (action.type) {
    case types.SELECT_LOCALE:
      return action.locale || state;
    default:
      return state;
  }
};

const openDrawer = (state = true, action) => {
  switch (action.type) {
    case types.DRAWER_ON:
      return true;
    case types.DRAWER_OFF:
      return false;
    default:
      return state;
  }
};

const openDrawerMobile = (state = false, action) => {
  switch (action.type) {
    case types.MOBILE_DRAWER_ON:
      return true;
    case types.MOBILE_DRAWER_OFF:
      return false;
    default:
      return state;
  }
};

const isOpenWorkStatus = (state = false, action) => {
  switch (action.type) {
    case types.WORK_STATUS_DRAWER_ON:
      return true;
    case types.WORK_STATUS_DRAWER_OFF:
      return false;
    default:
      return state;
  }
};

const isOpenOutput = (state = false, action) => {
  switch (action.type) {
    case types.OUTPUT_DRAWER_ON:
      return true;
    case types.OUTPUT_DRAWER_OFF:
      return false;
    default:
      return state;
  }
};

const isOpenImport = (state = false, action) => {
  switch (action.type) {
    case types.IMPORT_DRAWER_ON:
      return true;
    case types.IMPORT_DRAWER_OFF:
      return false;
    default:
      return state;
  }
};

const isOpenMaintenance = (state = false, action) => {
  switch (action.type) {
    case types.MAINTENANCE_DRAWER_ON:
      return true;
    case types.MAINTENANCE_DRAWER_OFF:
      return false;
    default:
      return state;
  }
};
const reducer = combineReducers({
  theme,
  locale,
  openDrawer,
  openDrawerMobile,
  isOpenWorkStatus,
  isOpenOutput,
  isOpenImport,
  isOpenMaintenance,
});
export default reducer;
